module.exports = __webpack_public_path__ + "static/media/Gagalin-Regular.ed3e2523.woff";